import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { getStatusConfig } from '../constant';
import styles from '../VehicleCompatibility.module.scss'
import { getBusTypeFromVin, resolveMeasurementStatus } from '../VehicleModelHelper';

const PidLabel = ({
  dataPoolIdentifier,
  vin,
  modelPids,
  model,
  showLabel = true
}) => {
  const { t } = useTranslation();

  const { status, calculated, tooltip } = useMemo(() => {
    const statusConfig = getStatusConfig();
    const busType = getBusTypeFromVin(vin);
    const { status, calculated } = resolveMeasurementStatus(dataPoolIdentifier, modelPids, busType, statusConfig, model);
    return {
      status,
      calculated,
      tooltip: t(status.label) + (calculated ? t('VehicleModel.Calculated') : '')
    };
  }, [dataPoolIdentifier, vin, modelPids, t]);

  const Icon = status.icon;

  return (
    <Tooltip title={tooltip} placement="top">
      <div className={showLabel ? styles.pidLabel : ''}>
        <div className={styles.iconWrapper}>
          <Icon style={{ color: status.color, fontSize: '22px', lineHeight: '22px' }} />
          {calculated && <sup>*</sup>}
        </div>
        {showLabel && <span>{t('VehicleModel.PidName.' + dataPoolIdentifier.key, { defaultValue: dataPoolIdentifier.value })}</span>}
      </div>
    </Tooltip>
  )
}

export default PidLabel;